import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { processSteps } from '../collectionForm/utils';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, events, traits, token, version } = opt;
  const style = document.createElement('style');
  traitManager.addType(traits.link.type, {
    createInput({ trait }) {
      const input = document.createElement('select');
      input.classList.add('workflow-event-field');
      let selectOneOption = document.createElement('option');
      selectOneOption.text = '- Select One -';
      selectOneOption.value = '';
      input.append(selectOneOption);
      for (let i = 0; i < events.length; i++) {
        let option = document.createElement('option');
        option.text = events[i].eventTitle;
        option.value = events[i].eventName;
        input.append(option);
      }

      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `
      <div class="row settings-workflow-event--progress-bar" style="display: none;">
      <div class="container">
        <div class="progress">
          <div class="progress-bar"></div>
        </div>
      </div>
      </div>
      <hr class="settings-workflow-event--progress-bar-hr" style="display: none;"/>
      <div id="WFE" class="settings-workflow-event--progress" style="display: none;">
        <div class="gjs-container workflow-event-container pb-1">
          <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
            <div class="badge badge-default cms--progress--step-3">
              <i class="wb webconnect"></i>
              <span class="step--desc">Step 3: Select Event</span>
            </div>
            <div class="cms-create-event-container" style="flex-grow: 1">
              <div class="gjs-row" style="flex-direction: row-reverse;">
                <a href=${getBuilderConfigURL()}events/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
                  <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Event
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
        `;

      const elem = document.createElement('div');
      elem.classList.add('custom-field');
      elem.innerHTML = `
      <div id="WFEV" class="settings-workflow-event-validation--progress pt-1" style="display: none;">
        <div class="gjs-container workflow-event-validation-container pb-0">
          <div class="gjs-row mx-auto pb-0">
            <div class="badge badge-default cms--progress--step-2">
              <i class="wb webconnect"></i>
              <span class="step--desc">Step 2: Select Validation (Optional)</span>
            </div>
          </div>
        </div>
      </div>
        `;
      el.append(input);
      el.append(elem);
      return el;
    },
    onEvent({ elInput, component }) {
      const name = this.model.get('name');
      const cmsProgressBarContainer = component.getTrait('collectionName')
        ? document.querySelector('.settings--progress-bar')
        : elInput.querySelector('.settings-workflow-event--progress-bar');
      const cmsProgressStep = elInput.querySelector('.settings-workflow-event--progress');
      const workflowEventField = elInput.querySelector('.workflow-event-field');

      if (name === 'onsubmit') {
        const attrs = component.getAttributes();
        if (attrs['data-form-collection']) {
          cmsProgressStep.style.display = 'block';
        } else {
          cmsProgressStep.style.display = 'none';
        }

        if (workflowEventField.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (attrs['data-form-collection']) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          }
          if (attrs['data-form-validation']) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
          }
        }
      }

      if (workflowEventField.value) {
        if (name === 'onsubmit') {
          if (
            component.get('type') === 'link-box' &&
            component.getAttributes() &&
            !component.getAttributes().hasOwnProperty('href')
          ) {
            component.addAttributes({
              [name]: 'return ' + workflowEventField.value + '(event)',
              href: '',
            });
          } else {
            component.addAttributes({ [name]: 'return ' + workflowEventField.value + '(event)' });
          }

          if (name === 'onsubmit' && component.get('type') === 'add-remove-collection-form') {
            cmsProgressStep.style.display = 'none';
          }
        } else {
          const attr = { [name]: workflowEventField.value + '(event)' };

          if (
            component.get('type') === 'link-box' &&
            component.getAttributes() &&
            !component.getAttributes().hasOwnProperty('href')
          ) {
            attr['href'] = '';
          }

          component.addAttributes(attr);
        }
      } else {
        const attr = component.getAttributes();
        if (
          component.get('type') === 'link-box' &&
          component.getAttributes() &&
          !component.getAttributes().hasOwnProperty('href')
        ) {
          attr['href'] = '';
        }
        delete attr[name];
        component.setAttributes(attr);
      }
    },
    onUpdate({ elInput, component }) {
      const attr = component.getAttributes();
      const name = this.model.get('name');
      const collectionNameTrait = component.getTrait('collectionName');
      const cmsProgressBarContainer =
        collectionNameTrait && collectionNameTrait.el
          ? collectionNameTrait.el.children[0]
          : elInput.querySelector('.settings-workflow-event--progress-bar');
      const cmsProgressStep = elInput.querySelector('.settings-workflow-event--progress');
      const workflowEventContainer = elInput.querySelector('.workflow-event-container');
      const workflowEventField = elInput.querySelector('.workflow-event-field');
      const formComponents = ['form', 'collection-form', 'add-remove-collection-form'];

      if (name === 'onsubmit') {
        elInput.value = attr[name]
          ? attr[name].replace('return', '').replace('(event)', '').trim()
          : '';
        workflowEventField.value = attr[name]
          ? attr[name].replace('return', '').replace('(event)', '').trim()
          : '';

        if (!formComponents.includes(component.get('type'))) {
          const progressBarContainer = elInput.querySelector(
            '.settings-workflow-event--progress-bar',
          );
          const progressBarContainerHr = elInput.querySelector(
            '.settings-workflow-event--progress-bar-hr',
          );
          const stepDesc = workflowEventContainer.querySelector('.step--desc');
          const workflowEventValidationContainer = elInput.querySelector(
            '.settings-workflow-event-validation--progress',
          );
          progressBarContainer.style.display = 'block';
          progressBarContainerHr.style.display = 'block';
          cmsProgressStep.style.display = 'block';
          stepDesc.innerHTML = `Step 1: Select Event`;
          workflowEventValidationContainer.style.display = 'none';
          if (component.get('type') === 'sign-up-form') {
            workflowEventValidationContainer.style.display = 'block';
          }
        } else {
          if (
            component.get('type') !== 'add-remove-collection-form' &&
            attr['data-form-collection']
          ) {
            cmsProgressStep.style.display = 'block';
          } else {
            cmsProgressStep.style.display = 'none';
          }
        }
        if (workflowEventField.value) {
          if (component.get('type') === 'sign-up-form') {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            if (attr['data-form-validation']) {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }
          } else {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (component.get('type') !== 'sign-up-form') {
            if (attr['data-form-collection']) {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            }
            if (attr['data-form-validation']) {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }
          }
        }
      } else {
        elInput.value = attr[name] ? attr[name].replace('(event)', '').trim() : '';
        workflowEventField.value = attr[name] ? attr[name].replace('(event)', '').trim() : '';
      }
    },
  });
}
